import { render, staticRenderFns } from "./InfopointTable.vue?vue&type=template&id=595388db"
import script from "./InfopointTable.vue?vue&type=script&lang=js"
export * from "./InfopointTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports